import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Modal } from '@atlaskit/onboarding';
import { buttonActionTypes } from '../../common/types/button';
import HtmlContent from '../../controllers/utils/html-content';
function header() {
  return null;
}

// eslint-disable-next-line @repo/internal/react/no-class-components
var ModalDialog = /*#__PURE__*/function (_Component) {
  function ModalDialog() {
    var _this;
    _classCallCheck(this, ModalDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ModalDialog, [].concat(args));
    _defineProperty(_this, "onPrimaryAction", function () {
      _this.props.fireClickEvent('primary');
    });
    _defineProperty(_this, "onSecondaryAction", function () {
      _this.props.fireClickEvent('secondary');
    });
    return _this;
  }
  _inherits(ModalDialog, _Component);
  return _createClass(ModalDialog, [{
    key: "getActionButton",
    value: function getActionButton(action, text, _onClick) {
      return {
        text: text,
        onClick: function onClick(e) {
          if (action.type === buttonActionTypes.LINK && action.data) {
            window.open(action.data.url, action.data.target);
          }
          _onClick(e);
        }
      };
    }
  }, {
    key: "getActions",
    value: function getActions() {
      var _this$props = this.props,
        primaryAction = _this$props.primaryAction,
        primaryText = _this$props.primaryText,
        secondaryAction = _this$props.secondaryAction,
        secondaryText = _this$props.secondaryText;
      var actions = [];
      if (primaryAction && primaryText) {
        actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
      }
      if (secondaryAction && secondaryText) {
        actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
      }
      return actions;
    }
  }, {
    key: "getAdditionalModalProps",
    value: function getAdditionalModalProps() {
      var props = {};
      var imageSrc = this.props.imageSrc;
      if (imageSrc) {
        props.image = imageSrc;
      } else {
        props.header = header;
      }
      return props;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        title = _this$props2.title,
        body = _this$props2.body;
      return /*#__PURE__*/React.createElement(Modal, _extends({
        actions: this.getActions(),
        heading: title
      }, this.getAdditionalModalProps()), /*#__PURE__*/React.createElement(HtmlContent, {
        html: body
      }));
    }
  }]);
}(Component);
export { ModalDialog as default };